import clsx from 'clsx'
import React from 'react'
import Typography, { TypographyVariant } from '../typography/Typography'

interface CustomButtonProps {
  title: string
  bgColor?: string
  textColor?: string
  circleColor?: string
  fontSize?: string
  typographyVariant?: TypographyVariant
  className?: string
  onClickUrl?: string
  onClickFunc?: () => void
}

const CustomButton = ({
  title,
  bgColor = 'bg-green-main',
  textColor = 'text-black',
  typographyVariant = 'buttonLarge',
  className = '',
  onClickUrl,
  onClickFunc,
}: CustomButtonProps) => {
  return onClickFunc ? (
    <div
      className={clsx(
        `${bgColor} ${textColor} rounded-full py-2.5 px-6 font-black relative flex items-center justify-center hover:cursor-pointer w-fit z-50 border-1 border-green-main bg-transparent text-green-main ${
          bgColor === '' &&
          'hover:bg-[#61F7B1] focus:bg-[#00CE80] focus:text-white'
        } `,
        className
      )}
      onClick={onClickFunc}
      // href={onClickUrl}
      // target="_blank"
    >
      <Typography
        variant={typographyVariant}
        type="span"
        weight="900"
        className={clsx('w-fit ')}
      >
        {title}
      </Typography>

      {/* <div
        className={`absolute right-0 top-0 bottom-0 my-auto aspect-square rounded-full ${circleColor}`}
      ></div> */}
    </div>
  ) : (
    <a
      className={clsx(
        `${bgColor} ${textColor} rounded-full py-2.5 px-6 font-black relative flex items-center justify-center hover:cursor-pointer w-fit z-50  border-1 border-green-main bg-transparent text-green-main ${
          bgColor === '' &&
          'hover:bg-[#61F7B1] focus:bg-[#00CE80] focus:text-white'
        } ${
          bgColor === '' &&
          'hover:bg-[#187DF1] focus:bg-[#161B85] focus:text-white'
        }`,
        className
      )}
      href={onClickUrl}
      target="_blank"
    >
      <Typography
        variant={typographyVariant}
        type="span"
        weight="900"
        className={clsx('w-fit ')}
      >
        {title}
      </Typography>

      {/* <div
        className={`absolute right-0 top-0 bottom-0 my-auto aspect-square rounded-full ${circleColor}`}
      ></div> */}
    </a>
  )
}

export default CustomButton
